
gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(DrawSVGPlugin);


function lenisScroll(){
  return new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical',
    smooth: true
  });
}
var lenis = lenisScroll();
function raf(time) {
  if( lenis !== undefined ){
    lenis.raf(time)
    requestAnimationFrame(raf);
  }
}
if( lenis !== undefined ){
  requestAnimationFrame(raf);
}
var targetLinkElement = null;
// // fix for id links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      let targetId = this.getAttribute('href');
      targetLinkElement = document.querySelector(targetId);

      if (targetLinkElement) {
        targetLinkElement.classList.add('clicked');
        lenis.scrollTo(targetLinkElement);
        setTimeout( function(){
          targetLinkElement.classList.remove('clicked');
        }, 1000);
      }
  });
});

let innerContainerBespoke = document.querySelector('.wt-feature-bespoke-list');
let innerSectionsBespoke = gsap.utils.toArray(".wt-feature-bespoke-list-item");

if (innerContainerBespoke) {
  let innersBespoke = gsap.utils.toArray('.wt-feature-bespoke-list-item-inner');

  // Set the default wheelSpeed for ScrollTrigger
  ScrollTrigger.defaults({
    wheelSpeed: 1 // Reduces scroll speed on trackpads
  });

  if (innersBespoke.length) {
    let p = 100;

    if (window.innerWidth > 767) {
      innersBespoke.forEach(function (innersBespokeItem, index) {
        let add = 10;
        let totalPercent = p + (10 * index);

        gsap.from(innersBespokeItem, {
          x: totalPercent + 'vw',
          duration: 1,
          scrollTrigger: {
            trigger: innersBespokeItem,
            start: "top 100%",
            end: "top 20%",
            scrub: 2, // Updated scrub value to 2
          }
        });
      });
    } else {
      let innerSectionsBespokeSingle = document.querySelector('.wt-feature-bespoke-list-item-inner');
      let innerSectionsBespokeSection = document.querySelector('#shopify-section-service-bespoke-order');
      let innerSectionsBespokes = gsap.utils.toArray('.wt-feature-bespoke-list-item-inner');

      if (innerContainerBespoke) {
        let p = innerSectionsBespokeSingle.offsetWidth;
        let totalWidth = p * (innerSectionsBespoke.length - 1);
        totalWidth = p * innerSectionsBespoke.length;

        gsap.to(innerSectionsBespoke, {
          xPercent: -100 * (innerSectionsBespoke.length - 1) + 'vw',
          ease: "none",
          scrollTrigger: {
            trigger: ".wt-feature-bespoke",
            start: "top top",
            end: `+=${totalWidth - 200}`,
            scrub: 2, // Updated scrub value to 2
            pin: true,
            pinSpacing: true, // Add space around the pinned element
            anticipatePin: 1,
          }
        });

        if (innerSectionsBespokes.length) {
          let trigger = 0;
          let addTranslate = 100; // 0 for desktop
          let screenWidth = 50;

          if (window.innerWidth < 768) {
            addTranslate = 100; // 60 for mobile
            screenWidth = 100;
          }

          innerSectionsBespokes.forEach(function (innerSectionsBespokesItem, index) {
            trigger = totalWidth - (p * index);
            let totalPercent = p + addTranslate;

            gsap.from(innerSectionsBespokesItem, {
              x: totalPercent,
              duration: 1,
              scrollTrigger: {
                trigger: innerSectionsBespokeSection,
                start: (p * index - 200) + 'px', // Added plus 200 to start animation a little earlier
                end: `+=${totalWidth / innerSectionsBespokes.length}px`,
                scrub: 2, // Updated scrub value to 2
              }
            });
          });
        }
      }
    }
  }
}

let whyWorktonesLists = document.querySelector('.custom-worktones-right');
let whyWorktonesListsItems = gsap.utils.toArray(".custom-worktones-right-item");
let whyWorktonesSection = document.querySelector('#shopify-section-custom-worktones');
let whyWorktonesListsItemsSingle = document.querySelector('.custom-worktones-right-item');

if (whyWorktonesLists) {
  let p = whyWorktonesListsItemsSingle.offsetWidth;
  let totalWidth = p * (whyWorktonesListsItems.length);

  gsap.to(whyWorktonesListsItems, {
    xPercent: -100 * (totalWidth) + 'vw', // You can reduce the scale here if needed
    ease: "power2.inOut", // Adjusted to a smoother easing function
    scrollTrigger: {
      trigger: ".custom-worktones",
      start: "top top",
      end: `+=${totalWidth}`,
      scrub: 3, // Slows down the animation for smoother scroll
      pin: true,
      pinSpacing: true,
      anticipatePin: 1,
    }
  });

  let whyWorktones = gsap.utils.toArray('.custom-worktones-right-item-inner');
  if (whyWorktones.length) {
    let addTranslate = 100; // Default for desktop
    let screenWidth = 50;

    if (window.innerWidth < 768) {   
      addTranslate = 100; // 60 for mobile
      screenWidth = 100;
    }

    // Set wheel speed to handle trackpad scroll speed
    ScrollTrigger.defaults({
      wheelSpeed: 2 // Reduces scroll speed on trackpads
    });

    whyWorktones.forEach(function (whyWorktonesItem, index) {
      let trigger = totalWidth - (p * index);
      console.log('start:', (p * index - 200) + 'px');
      console.log('end:', `+=${(totalWidth / whyWorktones.length)}px`);
      
      let offset = 0;
      if (window.innerWidth > 576) {   
        offset = 10;
      }

      let totalPercent = `+=${(100 - (offset * index))}vw`;
      gsap.from(whyWorktonesItem, {
        x: totalPercent,
        duration: 1,
        scrollTrigger: {
          trigger: whyWorktonesSection,
          start: (index * totalWidth / whyWorktones.length) + 'px', // Adjusted to start earlier
          end: `+=${(totalWidth / whyWorktones.length)}px`,
          scrub: true,
        }
      });
    });
  }
}


/**
 * Animation for Process section Embroidery and Bespoke page
 */
let section = document.querySelector(".wt-feature-process-wrapper");
if( section ){
  // let section = document.querySelector("#shopify-section-service-bespoke-process");
  let scrollContainer = section.querySelector(".scroll-container");
  let containerWidth = scrollContainer.scrollWidth;
  $(scrollContainer).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: false,
    adaptiveHeight: true,
    infinite: false,
    useTransform: true,
    speed: 1000,
    cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',   
    centerMode: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
              speed: 400,
              fade: true,
            },
        },
    ],
  }); 

  let lastScrollY = 0;
  let isScrolling = false; // Add an isScrolling flag
  // Listen for scroll events on the section with debounce
  scrollContainer.addEventListener('wheel', 
    // debounce(
      function(event) {
    // Prevent the default scroll behavior when transitioning slides
    if (isScrolling) return; // Ignore if currently scrolling
    let currentSlide = $(scrollContainer).slick('slickCurrentSlide');
    let totalSlides = $(scrollContainer).slick('getSlick').slideCount;
    // Determine scroll direction
    if (event.deltaY > 0) {
      // Scroll down
      if (currentSlide < totalSlides - 1) {
        event.preventDefault(); // Prevent default scroll behavior
        isScrolling = true; // Set scrolling flag
        handleSlideTransition('next'); // Move to next slide
      } else {
        // Allow scrolling down when on the last slide
        lenis.start();
      }
    } else if (event.deltaY < 0) {
      // Scroll up
      if (currentSlide > 0) {
        event.preventDefault(); // Prevent default scroll behavior
        isScrolling = true; // Set scrolling flag
        handleSlideTransition('prev'); // Move to previous slide
      } else {
        // Allow scrolling up when on the first slide
        lenis.start();
      }
    }

    // Reset the scrolling flag after a short delay
    setTimeout(() => {
      isScrolling = false; // Reset scrolling flag
    }, 400); // Adjust duration to match slick's speed
  }
  // , 80), { passive: false }
  ); // Adjust the debounce time (100ms) as needed

  lenis.on("scroll", (event) => {
    if( targetLinkElement && targetLinkElement.classList.contains('clicked') ){    
      return false;
    }
    let currentSlide = $(scrollContainer).slick('slickCurrentSlide');
    let totalSlides = $(scrollContainer).slick('getSlick').slideCount;
    let sectionRect = scrollContainer.getBoundingClientRect();
    let scrollTop = event.animatedScroll; // Current scroll position
    let screenHeight = window.innerHeight; // Height of the viewport
    let sectionTop = $(section).position().top;
    if( window.innerWidth < 1500 ){
      sectionTop = sectionTop + 100;
    }
    let scrollContainerBottom = $(scrollContainer).height() + sectionTop;
    let isSectionInView = (scrollTop >= sectionTop) && (scrollTop < (scrollContainerBottom - 300) && window.innerWidth > 1180 ); // only true when it is in viewport and browsed from desktop
    
    if (isSectionInView) {
      let currentScrollY = window.scrollY;

      // Check if scrolling is happening
      if (!isScrolling) {
        // Determine scroll direction
        if (currentScrollY > lastScrollY) {
          // Scroll down
          if (currentSlide < totalSlides - 1) {
            lenis.stop();
          } else {
            lenis.start();
          }
        } else if (currentScrollY < lastScrollY) {
          // Scroll up
          if (currentSlide > 0) {
            lenis.stop();
          } else {
            lenis.start();
          }
        }
      }

      // Update last scroll position
      lastScrollY = currentScrollY;
    }
  });
  // Debounce function to limit the frequency of the scroll event
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      let later = () => {
        timeout = null;
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  // Function to handle slide transitions based on direction
  function handleSlideTransition(direction) {
    if (direction === 'next') {
      $(scrollContainer).slick('slickNext');
    } else if (direction === 'prev') {
      $(scrollContainer).slick('slickPrev');
    }
  }
}